<template> 
  <v-container fluid fill-height pa-0>
    <v-layout row fill-height>
      <!-- Country selection buttons -->
      <div :style="$vuetify.breakpoint.smAndUp ? 'position:absolute;top:10%;right:15%' : 'position:absolute;top:60px;right:10px'">
        <v-btn
          v-for="(comm, c) in config.SUPPORTED_COUNTRIES"
          :key="c"
          fab
          small
          flat
          :class="(commCountryCode === comm.country_code ? 'grey lighten-2 ' : '') + 'ma-0'"
          @click="changeCountry(comm.country_code, comm.country)"
        >
          <flag style="font-size:16px" :squared="false" :iso="comm.country_code.toLowerCase()"></flag>
        </v-btn>
      </div>

      <!-- Left side with fixed image -->
      <div class="left-panel">
        <img src="/static/img/others/integrafms.png" class="side-img">
      </div>
      

      <!-- Right side with login/join form -->
      <div class="right-panel d-flex align-center justify-center">
        <div class="form-container text-xs-center">
          <img  height="150" width="250" src="/static/img/logo/integra_logo.png">

          <v-form @submit.prevent="joinComm">
            <v-layout row wrap>
              <v-flex xs12 class="mt-3">
                <v-autocomplete
                  :label="'Search & join your community in ' + commLocConfig.country"
                  :loading="loading"
                  :items="items"
                  :search-input.sync="search"
                  v-model.trim="selComm"
                  :no-data-text="search ? 'Community not found in our records' : 'Start typing your community name'"
                  hide-details
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12>
                <v-btn type="submit" block color="primary">Join</v-btn>
              </v-flex>

              <v-flex xs12 class="mt-3">
                <v-btn block color="accent" light @click.native="login">
                  Already a member? Log in
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>

          <v-flex xs12 class="mt-4">
            <v-btn flat class="primary--text" small :href="website_url">
              Contact Us
            </v-btn>
          </v-flex>
        </div>
      </div>
    </v-layout>

    <!-- join community flow -->
    <join-comm
      :comm="selComm"
      :countrycode="commCountryCode"
      :country="commLocConfig.country"
      v-if="joining"
      v-on:closed="joining=false"
    ></join-comm>

    <!-- login flow -->
    <login
      :countrycode="commCountryCode"
      v-if="loging"
      v-on:closed="loging=false"
    ></login>

    <!-- snack bar for error reporting -->
    <v-snackbar
      :color="sbarCol"
      v-model="sbar"
      :timeout="3000"
      multi-line
    >
      <span class="mx-auto">{{ sbarMsg }}</span>
    </v-snackbar>
  </v-container>
</template>


<script>
import config from '@/config/app-cfg'
import JoinComm from '@/components/JoinComm'
import Login from '@/components/Login'

export default {
  props: ['action'],
  data: () => ({
    gradient: 'to top, rgba(50,50,50, .7), rgba(0,0,0, .7)',
    loading: false,
    comms: [],
    items: [],
    selComm: '',
    search: '',
    joining: false,
    loging: false,
    sbar: false,
    sbarMsg: '',
    sbarCol: 'error',
    config: config,
    commCountryCode: '',
    website_url: 'https://uniservice.in',
    commLocConfig: { country_code: 'IN', country: 'India' }
  }),
  watch: {
    search (val) {
      if (!val) {
        this.selComm = ''
      } else {
        val && val !== this.select && this.querySelections(val)
      }
    }
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    querySelections (v) {
      this.loading = true
      setTimeout(() => {
        this.items = this.comms.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500)
    },
    joinComm () {
      if (this.selComm) {
        this.joining = true
      } else {
        this.msg('Choose a community to join', true)
      }
    },
    login () {
      this.loging = true
    },
    changeCountry (countryCode) {
      this.commCountryCode = countryCode
      this.commLocConfig = config.SUPPORTED_COUNTRIES.find(
        rec => rec.country_code === countryCode
      )
      localStorage.setItem('WELCOME_COUNTRY_CODE', countryCode)
      this.loadCommList()
      this.$forceUpdate()
    },
    loadCommList () {
      var qry = { params: { country_code: this.commCountryCode } }
      this.axios
        .get(config.API_URL + '/getAvailableCommunity/', qry)
        .then(response => {
          this.comms = response.data.map(rec => rec.comm_name)
          this.querySelections('')
        })
        .catch(err => {
          alert(err.response.data)
        })
    },
    prepareOnboard () {
      this.selComm = ''
      this.joining = true
    }
  },
  created () {
    this.commCountryCode = localStorage.getItem('WELCOME_COUNTRY_CODE')
    if (!this.commCountryCode) {
      this.axios
        .get('https://ip2c.org/s')
        .then(response => {
          if (response) {
            let resAry = response.data.split(';')
            this.commCountryCode = resAry[1]
            if (
              config.SUPPORTED_COUNTRIES.findIndex(
                rec => rec.country_code === this.commCountryCode
              ) < 0
            ) {
              this.commCountryCode = 'IN'
            }
            this.changeCountry(this.commCountryCode)
          }
        })
        .catch(err => {
          console.log(err)
          this.changeCountry('IN')
        })
    } else {
      this.changeCountry(this.commCountryCode)
    }

    if (this.action === 'create') {
      this.prepareOnboard()
    }
  },
  components: {
    'join-comm': JoinComm,
    login: Login
  }
}
</script>


<style scoped>
html, body, #app {
  height: 100%;
  margin: 0;
  overflow: hidden; 
}
.left-panel {
  position: fixed;       
  top: 0;
  left: 0;
  width: 50%;            
  height: 100vh; 
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
}

.side-img {
  width: 100%;
  height: 100%;
  object-fit: cover;  
  display: block;
   object-position: center;
}

.right-panel {
  position: fixed;
  top: 0;
  left: 50%;          
  width: 50%;        
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-container {
  width: 100%;
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// Welcome.vue?a87351a0